'use strict';

var EventEmitter = require('events').EventEmitter;

var emitter = new EventEmitter();

module.exports = emitter;